module.exports = __webpack_public_path__ + "img/newsletter-arrow.87e049d.png";